import { render } from "./createGroup.vue?vue&type=template&id=e81a117a"
import script from "./createGroup.vue?vue&type=script&lang=js"
export * from "./createGroup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__